import { Box } from '@mui/system';
import Typography from '@mui/material/Typography';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon/FuseSvgIcon';
import { useContext, useState } from 'react';
import { FileFolderContext } from './HrPolicies';

function FileItem(props) {
  const { item } = props;
  const [ selectedItem , setSelectedItem ] = useContext(FileFolderContext);

  if (!item) {
    return null;
  }

  return (
    <Box
      sx={{ backgroundColor: 'background.paper' }}
      className="flex flex-col relative w-full sm:w-160 h-160 m-8 p-16 shadow rounded-16 cursor-pointer"
      onClick={() => setSelectedItem({...item, type: 'file'})}
    >
      <div className="flex flex-auto w-full items-center justify-center">
        <FuseSvgIcon className="" size={56} color="disabled">
          heroicons-outline:document
        </FuseSvgIcon>
      </div>
      <div className="flex shrink flex-col justify-center text-center">
        <Typography className="truncate text-12 font-medium">{item.fileName}</Typography>
        {item.contents && (
          <Typography className="truncate text-12 font-medium" color="text.secondary">
            {item.contents}
          </Typography>
        )}
      </div>
    </Box>
  );
}

export default FileItem;